export const SponsorsListSkeleton = () => {
	return (
		<div className="w-full min-w-[310px] animate-pulse pt-4 md:pt-8">
			<div className="flex flex-col gap-7 bg-gray-100 p-4">
				<div className="h-11 w-full rounded bg-gray-200"></div>
				<div className="h-24 w-full rounded bg-gray-200"></div>
			</div>

			<div className="flex flex-col gap-7 bg-gray-100 p-4">
				<div className="h-11 w-full rounded bg-gray-200"></div>

				<div className="flex gap-7">
					<div className="h-24 w-full rounded bg-gray-200"></div>
					<div className="h-24 w-full rounded bg-gray-200"></div>
					<div className="h-24 w-full rounded bg-gray-200"></div>
				</div>
			</div>

			<div className="flex flex-col gap-7 bg-gray-100 p-4">
				<div className="h-11 w-full rounded bg-gray-200"></div>

				<div className="flex gap-7">
					<div className="h-24 w-full rounded bg-gray-200"></div>
					<div className="h-24 w-full rounded bg-gray-200"></div>
					<div className="h-24 w-full rounded bg-gray-200"></div>
				</div>
			</div>
		</div>
	);
};
